import {Formik, FormikProps} from 'formik';

import useDynamicForm from "Components/DynamicForm/useDynamicForm";
import {Button} from "reactstrap";
import FieldsBuilder from "./fieldsBuilder";


const DynamicForm = ({
                       children,
                       structure,
                       onSubmit,
                       submitProps = {class: '', text: "Guardar"},
                       hideSubmitButton = false,
                       callback
                     }: any) => {
  const {formik} = useDynamicForm({structure, onSubmit})
  return (
    <Formik onSubmit={formik.submitForm} {...formik}>
      {({submitForm}: FormikProps<any>) => (
        <>
          <FieldsBuilder formik={formik} structure={structure} callback={callback}/>
          {children}
          <br/>
          {!hideSubmitButton &&
              <Button onClick={submitForm} className="d-flex flex-row-reverse">
                {submitProps.text}
              </Button>
          }
        </>
      )}
    </Formik>

  );
};


export default DynamicForm;
